import { CLAIMED_FOR_RESPONSE, CLAIMED_FOR_RESPONSE_DURING_REVIEW, CLAIMED_FOR_REVIEW, DISAGREED, RESPOND_AS_MANAGER, REVIEW_AS_MANAGER, EDIT_META_AS_MANAGER, VIEW_AS_MANAGER, VIEW_DIALOGUE_OPTIONS_AS_MANAGER } from "./message-state-constants/MessageStateConstants";
import { log as pilog } from "@limitless/common/utils";
import { isFieldEmpty } from "@limitless/common/utils/text-input-helper/TextInputHelper";
const ALL_EDITOR_STATES = {
  [CLAIMED_FOR_RESPONSE]: CLAIMED_FOR_RESPONSE,
  [CLAIMED_FOR_RESPONSE_DURING_REVIEW]: CLAIMED_FOR_RESPONSE_DURING_REVIEW,
  [CLAIMED_FOR_REVIEW]: CLAIMED_FOR_REVIEW,
  [DISAGREED]: DISAGREED,
  [RESPOND_AS_MANAGER]: RESPOND_AS_MANAGER,
  [REVIEW_AS_MANAGER]: REVIEW_AS_MANAGER,
  [EDIT_META_AS_MANAGER]: EDIT_META_AS_MANAGER,
  [VIEW_AS_MANAGER]: VIEW_AS_MANAGER,
  [VIEW_DIALOGUE_OPTIONS_AS_MANAGER]: VIEW_DIALOGUE_OPTIONS_AS_MANAGER
};

/**
 * this file needs gutting after v3.0 of Crowd Manager is designed and agreed.
 */

export const PREVIEW_ACTIONS = [{
  controlKey: "showProductCodes",
  mandatoryKey: "isProductCodeMandatory",
  component: "product-code-search",
  disabledTooltip: "Please select a product code",
  payloadKey: "msgClassification",
  standAloneCategory: true,
  category: "Product",
  validStates: ALL_EDITOR_STATES,
  validateField: field => {
    if (!field.pristine && !field.classificationCode) {
      return "Please select a product code";
    }
    return null;
  }
}, {
  controlKey: "showMessageCodes",
  mandatoryKey: "isMessageCodeMandatory",
  title: "Response Code",
  component: "categorise-by-codes",
  placeholder: "Select your response code",
  disabledTooltip: "Please select a response code",
  reasonCodeKey: "response",
  payloadKey: "responseCode",
  checkValueExists: true,
  payloadReasonDescriptionKey: "responseCodeDesc",
  id: "reasonCodeDropdown",
  category: "Categorise",
  validStates: ALL_EDITOR_STATES,
  validateField: field => {
    if (!field.pristine && !field.value) {
      return "Please select a response code";
    }
    return null;
  }
}, {
  controlKey: "showMessageTagsEditor",
  mandatoryKey: "isMessageTagsMandatory",
  title: "Tags",
  component: "categorise-by-tags",
  placeholder: "Type to search tags",
  payloadKey: "tags",
  id: "tagsAutocomplete",
  category: "Categorise",
  validStates: {
    [CLAIMED_FOR_RESPONSE]: CLAIMED_FOR_RESPONSE,
    [CLAIMED_FOR_RESPONSE_DURING_REVIEW]: CLAIMED_FOR_RESPONSE_DURING_REVIEW,
    [RESPOND_AS_MANAGER]: RESPOND_AS_MANAGER,
    [REVIEW_AS_MANAGER]: REVIEW_AS_MANAGER,
    [EDIT_META_AS_MANAGER]: EDIT_META_AS_MANAGER,
    [VIEW_AS_MANAGER]: VIEW_AS_MANAGER,
    [VIEW_DIALOGUE_OPTIONS_AS_MANAGER]: VIEW_DIALOGUE_OPTIONS_AS_MANAGER
  },
  validateField: field => {
    if (!field.pristine && field.value.length === 0) {
      return "Please enter one or more tag";
    }
    return null;
  }
}, {
  controlKey: "showDialogueNoteCapture",
  mandatoryKey: "isDialogueNoteCaptureMandatory",
  title: "Client Feedback",
  component: "feedback-by-input",
  placeholder: "Provide any feedback to the client about this conversation",
  tooltip: "Provide as much detail as possible",
  disabledTooltip: "Please provide client feedback",
  payloadKey: "dialogueNote",
  id: "dialogueNoteTextInput",
  category: "Feedback",
  validStates: {
    [CLAIMED_FOR_RESPONSE]: CLAIMED_FOR_RESPONSE,
    [CLAIMED_FOR_RESPONSE_DURING_REVIEW]: CLAIMED_FOR_RESPONSE_DURING_REVIEW,
    [VIEW_AS_MANAGER]: VIEW_AS_MANAGER,
    [VIEW_DIALOGUE_OPTIONS_AS_MANAGER]: VIEW_DIALOGUE_OPTIONS_AS_MANAGER
  },
  validateField: field => {
    if (!field.pristine && isFieldEmpty(field.value)) {
      return "Please provide client feedback";
    }
    return null;
  }
}, {
  controlKey: "showExpertPrefCapture",
  mandatoryKey: "isExpertPrefCaptureMandatory",
  title: "Would you like to see more conversations like this?",
  component: "feedback-by-vote",
  disabledTooltip: "Submit a vote on this conversation",
  payloadKey: "expertPrefVote",
  category: "Feedback",
  validStates: {
    [CLAIMED_FOR_RESPONSE]: CLAIMED_FOR_RESPONSE,
    [CLAIMED_FOR_RESPONSE_DURING_REVIEW]: CLAIMED_FOR_RESPONSE_DURING_REVIEW,
    [VIEW_AS_MANAGER]: VIEW_AS_MANAGER,
    [VIEW_DIALOGUE_OPTIONS_AS_MANAGER]: VIEW_DIALOGUE_OPTIONS_AS_MANAGER
  },
  data: [{
    title: "Yes",
    iconName: "thumb-up",
    tooltip: "Yes, please send more",
    payloadValue: "positive",
    id: "positivePrefVoteButton"
  }, {
    title: "No",
    iconName: "thumb-down",
    tooltip: "No, this wasn't to my liking",
    payloadValue: "negative",
    id: "negativePrefVoteButton"
  }],
  validateField: field => {
    if (!field.pristine && !field.value) {
      return "Submit a vote on this conversation";
    }
    return null;
  }
}];
export const getPreviewActions = message => {
  const log = pilog.getLogger("MessageEditorPreviewActionsMapps getPreviewActions");
  const {
    conversationState
  } = message;
  const {
    editorState
  } = conversationState;
  log.debug(conversationState);
  const previewActions = [...PREVIEW_ACTIONS];

  //first lets strip out actions that are not enabled
  const newActionCategories = previewActions.filter(action => {
    //remove anything that doesn't have a  enabled controlKey
    //e.g. showExpertPrefCapture is true
    return editorState[action.controlKey] === true;
  });
  return newActionCategories;
};